import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { TermsAPI } from '../../services/termsService';

class TermsAcceptanceModal extends Component {
  state = {
    agreed: false,
    submitting: false,
    error: null,
  };

  handleAccept = async () => {
    const { userId, current, onAccepted } = this.props;
    this.setState({ submitting: true, error: null });
    try {
      await TermsAPI.accept(userId, current.id);
      onAccepted();
    } catch (err) {
      this.setState({
        submitting: false,
        error: 'Could not save your acceptance. Please check your connection and try again.',
      });
    }
  };

  render() {
    const { current, onDeclined } = this.props;
    const { agreed, submitting, error } = this.state;

    return (
      <Modal
        show={true}
        backdrop="static"
        keyboard={false}
        size="lg"
        onHide={() => {}}
      >
        <Modal.Header>
          <Modal.Title>{current.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="border rounded p-3 bg-white mb-3"
            style={{ maxHeight: 400, overflowY: 'auto' }}
            dangerouslySetInnerHTML={{ __html: current.content }}
          />
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="terms-agree-checkbox"
              checked={agreed}
              disabled={submitting}
              onChange={(e) => this.setState({ agreed: e.target.checked })}
            />
            <label className="form-check-label" htmlFor="terms-agree-checkbox">
              I have read and agree to the Terms and Conditions.
            </label>
          </div>
          {error && (
            <div className="alert alert-danger mt-3 mb-0" role="alert">
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={onDeclined}
            disabled={submitting}
          >
            Decline
          </Button>
          <Button
            variant="primary"
            onClick={this.handleAccept}
            disabled={!agreed || submitting}
          >
            {submitting ? 'Saving...' : 'Accept'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default TermsAcceptanceModal;
